<template>
	<div class="areas margin-top-areas mb-5">
		<app-table
			:rows="rows"
			:columns="columns"
			value
			class="mt-3 is-not-selectable no-main-list"
			:main-list="false"
			:filter-columns="false"
			title="ÁREAS"
			icon-area
			@open-area="openArea('new-area')"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)" class="is-not-selectable border-top pl-row">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 2)">{{ props.row.totalEmployees }}</td>
				<td v-show="showRow(columns, 3)" class="text-xs-center" @click.stop="stopClick">
					<app-tooltip-button
						text="Editar"
						img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/new-file-1-(4).svg"
						@click-icon="openArea('edit', props.row.id)"
					/>
					<app-tooltip-button
						img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
						text="Eliminar"
						color="info"
						@click-icon="openArea('delete', props.row.id, props.row.name)"
					/>
				</td>
			</template>
		</app-table>
		<open-modal
			:dialog="openDialog"
			:title="title"
			:create="$v.$invalid && this.action !== 'delete'"
			@close-modal="closeModal"
			@create-employee="createArea"
		>
			<new-area 
				v-if="actionIs('new-area', 'edit')"
				:data="model"
				:title="titleActionArea"
			/>
			<delete-area
				v-if="actionIs('delete')"
				:name="areaName"
			></delete-area>
		</open-modal>
	</div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import deleteArea from '@/components/configuration/delete-area';
import newArea from '@/components/configuration/new-area';
import openModal from '@/components/configuration/open-modal';

function created() {
	this.listArea();
}

function actionIs(action, orAction) {
	return this.action === action || this.action === orAction;
}

async function getAreaInfo(id) {
	try {
		const { data: model } = await this.$httpPraktiko.get(`groups/${id}`);
		({ name: this.model.name, code: this.model.code } = model);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

async function listArea() {
	try {
		const response = await this.$httpPraktiko.get('groups');
		this.rows = response.data;
	} catch (error) {
		this.showGenericError();
	}
}

function openArea(action, id, name) {
	this.openDialog = true;
	this.action = action;
	this.areaId = id;
	if (action === 'edit') {
		this.title = 'Editar';
		this.getAreaInfo(this.areaId);
	} else if (action === 'delete') {
		this.title = 'Eliminar';
		this.areaName = name;
	} else {
		this.title = 'Crear';
	}
}

function titleActionArea() {
	const module = 'Área';
	return this.action === 'edit' ? `Editar ${module}` : `Crear ${module}`;
}

function closeModal(val) {
	this.openDialog = val;
	this.action = null;
	this.clearModal();
}

function validations() {
	return {
		model: {
			name: { required },
			code: { required, maxLength: maxLength(4) },
		},
	};
}

async function createArea() {
	let method = 'delete';
	let url = `groups/${this.areaId}`;
	let message = 'eliminó';
	let body = null;
	if (this.action !== 'delete') {
		method = this.action === 'edit' ? 'patch' : 'post';
		url = this.action === 'edit' ? `groups/${this.areaId}` : 'groups';
		message = this.action === 'edit' ? 'editó' : 'creó';
		body = this.model;
	}
	try {
		await this.$httpPraktiko[method](url, body);
		this.showNotification(`Se ${message} correctamente.`);
		this.closeModal(false);
		this.listArea();
	} catch (error) {
		if (error.status === 400) {
			if (error.data.message === 'GROUP_CODE_REPEATED') {
				this.showGenericError('El código ya existe');
			} else if (error.data.message === 'HAS_EMPLOYEES_ASSIGNED') {
				this.showGenericError('El área que intenta eliminar tiene empleados asignados.');
			}
		}
	}
}

function clearModal() {
	this.model = {
		name: '',
		code: '',
	};
}

function data() {
	return {
		action: null,
		areaId: 0,
		areaName: '',
		columns: [
			{ id: 1, name: 'NOMBRE DE ÁREA', value: 'name', visible: true, checked: true },
			{ id: 2, name: 'CANT. EMPLEADOS', value: 'quantity', visible: true, checked: true },
			{ id: 3, name: 'ACCIONES', visible: true, checked: true, flagVisible: true },
		],
		model: {
			name: '',
			code: '',
		},
		openDialog: false,
		rows: [],
		title: 'Crear',
	};
}

export default {
	name: 'areas',
	components: {
		deleteArea,
		newArea,
		openModal,
	},
	computed: {
		titleActionArea,
	},
	created,
	data,
	methods: {
		actionIs,
		clearModal,
		closeModal,
		createArea,
		getAreaInfo,
		listArea,
		openArea,
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/pages/configuration/areas.vue